import { render, staticRenderFns } from "./run-record-of-the-day.vue?vue&type=template&id=566cd0c4&scoped=true"
import script from "./run-record-of-the-day.vue?vue&type=script&lang=ts"
export * from "./run-record-of-the-day.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566cd0c4",
  null
  
)

export default component.exports